<template>
    <div class="enterprise-qualification-search">
        <!-- <el-collapse accordion>
            <el-collapse-item>
                <template slot="title">
                    <span style="color: #409eff;cursor: pointer;font-size: medium;">筛选&nbsp;&nbsp;<i
                            class="el-icon-zoom-in"></i></span>
                </template>
<el-card shadow="always">
    <div slot="header">
        <span>线索信息</span>
    </div>
    <el-form :inline="true" ref="searchArr" :model="searchArr" label-width="" class="form-horizontal">
        <!== <el-form-item label="企业状态:" prop="sta">
            <el-checkbox-group v-model="searchArr.sta">
                <el-checkbox label="1">存续</el-checkbox>
                <el-checkbox label="2">正常</el-checkbox>
                <el-checkbox label="3">在业</el-checkbox>
                <el-checkbox label="4">注销</el-checkbox>
                <el-checkbox label="5">吊销</el-checkbox>
                <el-checkbox label="6">撤销</el-checkbox>
                <el-checkbox label="7">迁出</el-checkbox>
            </el-checkbox-group>
            </el-form-item> ==>
            <el-form-item label="企业状态:" prop="sta">
                <el-select v-model="searchArr.sta" multiple placeholder="请选择" style="width: 100%" clearable filterable
                    size="medium" @click.native="loadSta" :loading="isLoadingSta">
                    <el-option v-for="item in options_sta" :key="item" :label="item" :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="成立日期:" prop="date_of_establishment">
                <el-date-picker size="medium" v-model="searchArr.date_of_establishment" type="year" align="right"
                    unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
                    value-format="yyyy">
                    <!== :picker-options="pickerOptions"==>
                </el-date-picker>
            </el-form-item>
            <el-form-item label="所在区域:" prop="">
                <!== <province-city-area ref="provinceCityArea" size="medium"
                    @provinceCityAreaChange="provinceCityAreaChange" /> ==>
                <el-select v-model="searchArr.in_province" multiple placeholder="省" style="width: 100%" clearable
                    filterable size="medium" @click.native="loadProvince" :loading="isLoadingSta">
                    <el-option v-for="item in options_province" :key="item" :label="item" :value="item">
                    </el-option>
                </el-select>
                -
                <el-select v-model="searchArr.in_city" multiple placeholder="市" style="width: 100%" clearable filterable
                    size="medium" @click.native="loadCity" :loading="isLoadingSta">
                    <el-option v-for="item in options_city" :key="item" :label="item" :value="item">
                    </el-option>
                </el-select>
                -
                <el-select v-model="searchArr.in_area" multiple placeholder="区" style="width: 100%" clearable filterable
                    size="medium" @click.native="loadArea" :loading="isLoadingSta">
                    <el-option v-for="item in options_area" :key="item" :label="item" :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="有无手机号:" prop="has_phone">
                <el-checkbox-group v-model="searchArr.has_phone">
                    <el-checkbox false-label="" true-label="1" name="status">有</el-checkbox>
                    <el-checkbox false-label="" true-label="2" name="status">无</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="是否微信:" prop="is_wechat">
                <el-checkbox-group v-model="searchArr.is_wechat">
                    <el-checkbox false-label="" true-label="1" name="status">是微信</el-checkbox>
                    <el-checkbox false-label="" true-label="2" name="status">非微信</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="有无渠道手机号:" prop="has_xlb_phone">
                <el-checkbox-group v-model="searchArr.has_xlb_phone">
                    <el-checkbox false-label="" true-label="1" name="status">有</el-checkbox>
                    <el-checkbox false-label="" true-label="2" name="status">无</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="有无清洗手机号:" prop="has_self_phone">
                <el-checkbox-group v-model="searchArr.has_self_phone">
                    <el-checkbox false-label="" true-label="1" name="status">有</el-checkbox>
                    <el-checkbox false-label="" true-label="2" name="status">无</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="是否会员:" prop="is_member">
                <el-checkbox-group v-model="searchArr.is_member">
                    <el-checkbox false-label="" true-label="1" name="status">是</el-checkbox>
                    <el-checkbox false-label="" true-label="2" name="status">否</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="是否订单:" prop="is_order">
                <el-checkbox-group v-model="searchArr.is_order">
                    <el-checkbox false-label="" true-label="1" name="status">是</el-checkbox>
                    <el-checkbox false-label="" true-label="2" name="status">否</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="服务过企业:" prop="is_business">
                <el-checkbox-group v-model="searchArr.is_business">
                    <el-checkbox false-label="" true-label="1" name="status">是</el-checkbox>
                    <el-checkbox false-label="" true-label="2" name="status">否</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
    </el-form>
</el-card>
<el-card shadow="always">
    <div slot="header">
        <span>资质信息</span>
    </div>
    <el-form :inline="true" ref="searchArr" :model="searchArr" label-width="" class="form-horizontal">
        <el-form-item label="资质分类:" prop="classification_of_qualification_certificates">
            <el-cascader style="width: 100%" placeholder="资质分类"
                v-model="searchArr.classification_of_qualification_certificates" filterable :props="customProps"
                size="medium" clearable></el-cascader>
            <!== :options="searchArr.options_cascader"==>
                <!== @click.stop="loadFirstLevel"==>
        </el-form-item>
        <el-form-item label="证书状态:" prop="certificate_status">
            <el-select v-model="searchArr.certificate_status" multiple placeholder="请选择" style="width: 100%" clearable
                filterable size="medium" @click.native="loadCertificateStatus" :loading="isLoadingSta">
                <el-option v-for="item in options_certificate_status" :key="item" :label="item" :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="发证日期:" prop="date_of_issue">
            <el-date-picker size="medium" v-model="searchArr.date_of_issue" type="daterange" align="right" unlink-panels
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                <!== :picker-options="pickerOptions"==>
            </el-date-picker>
        </el-form-item>
        <el-form-item label="有效期:" prop="valid_to">
            <el-date-picker size="medium" v-model="searchArr.valid_to" type="daterange" align="right" unlink-panels
                :range-separator="range_separator" :start-placeholder="start_placeholder"
                :end-placeholder="end_placeholder" value-format="yyyy-MM-dd" :picker-options="validToOptions">
                <!== :picker-options="pickerOptions"==>
            </el-date-picker>
        </el-form-item>
    </el-form>
</el-card>
<div style="text-align: center;padding-top: 0.2rem;">
    <el-button size="mini" type="primary" @click="submitForm()">查询</el-button>
    <el-button size="mini" @click="resetForm()">重置</el-button>
</div>
</el-collapse-item>
</el-collapse> -->
        <div style="margin-top: 0.2rem;display: flex;gap: 0.2rem;">
            <el-select v-model="searchArr.category_id" filterable remote reserve-keyword placeholder="请输入公司名称"
                size="medium" clearable :remote-method="searchRemoteCfcategory" :loading="searchLoading"
                @change="handleSearchCfcategory">
                <el-option v-for="searchCompany in searchCategories" :key="searchCompany" :label="searchCompany"
                    :value="searchCompany">
                </el-option>
            </el-select>
            <!-- <base-search size="medium"/>
            <enterprise-qualification-info-search size="medium"/> -->
            <!-- ysyEnterpriseQualificationDataFiltering -->

            <enterprise-qualification-data-filtering :value.sync="havingData"
                ref="enterpriseQualificationDataFiltering" />

            <div style="margin-left: auto;display: flex;gap:0.2rem">
                <!-- <el-button size="medium" type="primary" @click="openDistributeDialog()">创建任务</el-button> -->
                <!-- <el-button size="medium" type="primary" @click="buildTask">创建任务</el-button> -->
                <build-task ref="EnterpriseQualificationSearchBuildTask" :value.sync="cateId" :searchArr="havingData" />

                <el-button type="primary" size="medium" @click="taskBuildDetailDialog = true">打开任务详情</el-button>
            </div>

        </div>

        <!-- <el-dialog :visible.sync="dialog" @close="closeDialog" @beforeClose="beforeCloseDialog" width="50%" center>
            <template v-slot:title>
                <span class="cal-tas-m-dia-title">
                    分配资源
                </span>
            </template>

            <task-cate ref="taskCate" @handleSelected="handleSelected" />

            <div class="cal-tas-m-bg-con" v-if="showNext">
                <button-group :buttonGroup="distribute.dis_type" ref="buttonGroup" :options="buttonGroupOptions"
                    @buttonGroupChange="buttonGroupChange" />
                <div style="margin-top:0.2rem;text-align: center">
                    <span>分配条件(不选默认全部分配)</span>
                    <el-checkbox-group v-model="distribute.phone_cate" style="margin-top: 0.2rem">
                        <el-checkbox label="1">有手机号</el-checkbox>
                        <el-checkbox label="2">有渠道拉取</el-checkbox>
                        <el-checkbox label="3">有清洗号码</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div v-if="distribute.dis_type === 1">
                    <el-card shadow="hover" class="box-card">
                        <div slot="header" class="clearfix">
                            <span>选择人员</span>
                        </div>
                        <div class="text item">
                            <checkbox-com ref="checkboxCom" :options="callerOptions" label="username"></checkbox-com>
                            <!== <role-member/> ==>
                        </div>
                    </el-card>
                    <el-card shadow="hover" class="box-card">
                        <div slot="header" class="clearfix">
                            <span>每人分配条数</span>
                        </div>
                        <div class="text item">
                            <el-form :model="distribute" ref="distribute" label-width="0px" class="demo-dynamic">
                                <el-form-item prop="avgNum" label="" :rules="[
                { required: true, message: '请输入每人分配条数', trigger: 'blur' },
                { min: 1, message: '请输入正确的每人分配条数', trigger: 'blur' },
            ]">
                                    <el-input type="number" clearable v-model="distribute.avgNum"
                                        size="mini"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-card>
                </div>
                <div v-else-if="distribute.dis_type === 2" style="margin-top: 0.2rem;">
                    <checkbox-input ref="checkboxInput" :options="callerOptions" label="username" />
                </div>
                <div style="display: flex;margin-top: 0.2rem">
                    <div style="margin-left: auto;">
                        <el-button type="primary" @click.native="submitFormDis('distribute')" size="mini">提交</el-button>
                    </div>
                </div>
            </div>
        </el-dialog> -->

        <!-- <el-dialog :visible.sync="taskCateDialog" @close="closeDialog_taskCate"
            @beforeClose="beforeCloseDialog_taskCate" width="50%" center>
            <template v-slot:title>
                <span class="cal-tas-m-dia-title">
                    创建任务
                </span>
            </template>

            <task-cate ref="taskCate" @handleSelected="handleSelectedNew" />

            <div style="display: flex;margin-top: 0.2rem" v-if="showNext">
                <div style="margin-left: auto;">
                    <el-button type="primary" @click.native="submitFormDis('distribute')" size="mini">提交</el-button>
                </div>
            </div>
        </el-dialog> -->

        <el-dialog :visible.sync="taskBuildDetailDialog" @close="closeDialog_taskBuildDetail"
            @beforeClose="beforeCloseDialog_taskBuildDetail" width="50%" center>
            <template v-slot:title>
                <span class="cal-tas-m-dia-title">
                    创建详情
                </span>
            </template>

            <enterprise-qualification-show-task-build-detail v-if="taskBuildDetailDialog" />
        </el-dialog>
    </div>
</template>

<script>
import ProvinceCityArea from '../../../commonReform/ProvinceCityArea';
import ButtonGroup from '../../../commonReform/ButtonGroup.vue'
import CheckboxCom from '../../../commonReform/CheckboxCom';
import CheckboxInput from '../../../commonReform/CheckboxInput';
import TaskCate from './TaskCate';
// import BaseSearch from './BaseSearch';
// import EnterpriseQualificationInfoSearch from './EnterpriseQualificationInfoSearch';
const EnterpriseQualificationDataFiltering = () => import('./EnterpriseQualificationDataFiltering.vue');
const BuildTask = () => import('@/pages/CallTaskResource/components/BuildTask')
const EnterpriseQualificationShowTaskBuildDetail = () => import('@/pages/CallTaskResource/components/EnterpriseQualificationShowTaskBuildDetail')
import { AutoHyperfHost } from '@/config'

export default {
    name: 'EnterpriseQualificationSearch',
    components: { ProvinceCityArea, ButtonGroup, CheckboxCom, CheckboxInput, TaskCate, EnterpriseQualificationDataFiltering, BuildTask, EnterpriseQualificationShowTaskBuildDetail },
    data() {
        return {
            searchArr: {
                category_id: '',
                sta: [],
                date_of_establishment: '',
                in_province: '',
                in_city: '',
                in_area: '',
                has_phone: '',
                is_wechat: '',
                has_xlb_phone: '',
                has_self_phone: '',
                is_member: '',
                is_order: '',
                is_business: '',
                date_of_issue: '',
                valid_to: '',
                classification_of_qualification_certificates: [],
                certificate_status: [],
            },
            searchCategories: [],
            searchLoading: false,
            options_sta: [],
            isLoadingSta: false,
            options_province: [],
            options_city: [],
            options_area: [],
            qualificationCertificateDialog: false,
            customProps: {
                multiple: true,
                value: 'id',
                label: 'name',
                // children: 'c'
                lazy: true,
                lazyLoad: this.loadCascader,
                checkStrictly: true
            },
            options_certificate_status: [],
            dialog: false,
            buttonGroupOptions: [
                {
                    label: '平均分配',
                    value: 1
                },
                {
                    label: '自定义分配',
                    value: 2
                },
            ],
            distribute: {
                dis_type: 1,
                avgNum: null,
                phone_cate: ['1', '2', '3']
            },
            callerOptions: [],
            showNext: false,
            cateId: '',
            taskCateDialog: false,
            havingData: '',
            taskBuildDetailDialog: false,
        }
    },
    methods: {
        loadCascader(node, resolve) {
            const data = this.loadLevel(node.value ? node.value : 0)
            data.then(data => {
                resolve(data)
            })
            // console.log(data,'data')
            // resolve(this.options_cascader)
        },
        searchRemoteCfcategory(query) {
            if (query !== "") {
                this.searchLoading = true;
                setTimeout(() => {
                    this.searchLoading = false;
                    this.searchItem(query);
                }, 200);
            } else {
                this.searchCategories = [];
            }
        },
        searchItem(query) {
            this.$axios
                .get("api/api3_call_task_remote_search_company", {
                    params: {
                        search: query,
                    },
                })
                .then(({ data }) => {
                    if (data.code === 200) {
                        this.searchCategories = data.data;
                    }
                })
                .catch();
        },
        handleSearchCfcategory(query) {
            // this.searcher = query
            // this.loadTable();
            this.$emit('searchCompany', query)
        },
        submitForm() {
            this.$emit('doSearch', this.searchArr)
        },
        doSearch() {
            this.$emit('doSearch', this.searchArr)
        },
        resetForm() {
            this.searchArr.sta = []
            this.searchArr.date_of_establishment = ''
            this.searchArr.in_province = ''
            // this.$refs.provinceCityArea.pca.province = ''
            this.searchArr.in_city = ''
            // this.$refs.provinceCityArea.pca.city = ''
            this.searchArr.in_area = ''
            // this.$refs.provinceCityArea.pca.area = ''
            this.searchArr.has_phone = ''
            this.searchArr.is_wechat = ''
            this.searchArr.has_xlb_phone = ''
            this.searchArr.has_self_phone = ''
            this.searchArr.is_member = ''
            this.searchArr.is_order = ''
            this.searchArr.is_business = ''
            this.searchArr.date_of_issue = ''
            this.searchArr.valid_to = ''
            this.searchArr.options_cascader = []
            this.searchArr.classification_of_qualification_certificates = []
            this.searchArr.certificate_status = []
        },
        provinceCityAreaChange(val) {
            // console.log(val, 'val')
            this.searchArr[val.k] = val.v
            // console.log(this.searchArr)
        },
        loadSta() {
            this.isLoadingSta = true
            this.$axios
                .get("/api/api3_call_task_load_sta", {
                    params: {
                        // search: query,
                    },
                    loadingClose: true,
                })
                .then(({ data }) => {
                    if (data.code === 0) {
                        this.isLoadingSta = false
                        this.options_sta = data.data;
                    }
                })
                .catch();
        },
        loadCertificateStatus() {
            this.isLoadingSta = true
            this.$axios
                .get("/api/api3_call_task_load_certificate_status", {
                    params: {
                        // search: query,
                    },
                    loadingClose: true,
                })
                .then(({ data }) => {
                    if (data.code === 0) {
                        this.isLoadingSta = false
                        this.options_certificate_status = data.data;
                    }
                })
                .catch();
        },
        loadProvince() {
            this.isLoadingSta = true
            this.$axios
                .get("/api/api3_call_task_load_province", {
                    params: {
                        // search: query,
                    },
                    loadingClose: true,
                })
                .then(({ data }) => {
                    if (data.code === 0) {
                        this.isLoadingSta = false
                        this.options_province = data.data;
                    }
                })
                .catch();
        },
        loadCity() {
            this.isLoadingSta = true
            this.$axios
                .get("/api/api3_call_task_load_city", {
                    params: {
                        // search: query,
                    },
                    loadingClose: true,
                })
                .then(({ data }) => {
                    if (data.code === 0) {
                        this.isLoadingSta = false
                        this.options_city = data.data;
                    }
                })
                .catch();
        },
        loadArea() {
            this.isLoadingSta = true
            this.$axios
                .get("/api/api3_call_task_load_area", {
                    params: {
                        // search: query,
                    },
                    loadingClose: true,
                })
                .then(({ data }) => {
                    if (data.code === 0) {
                        this.isLoadingSta = false
                        this.options_area = data.data;
                    }
                })
                .catch();
        },
        openQualificationCertificateDialog() {
            this.isLoadingSta = true
            this.$axios
                .get("/api/api3_call_task_load_qualification_certificate_first_level", {
                    params: {
                        // search: query,
                    },
                    loadingClose: true,
                })
                .then(({ data }) => {
                    if (data.code === 0) {
                        this.isLoadingSta = false
                        this.first_level_box = data.data;
                    }
                })
                .catch();
            this.qualificationCertificateDialog = true
        },
        loadLevel(id) {
            return this.$axios
                .get("/api/api3_call_task_load_qualification_certificate_level", {
                    params: {
                        id
                    },
                    loadingClose: true,
                })
                .then(({ data }) => {
                    if (data.code === 0) {
                        return data.data
                    }
                })
                .catch();
        },
        loadFirstLevel() {
            this.$axios
                .get("/api/api3_call_task_load_qualification_certificate_first_level", {
                    params: {
                        // id
                    },
                    loadingClose: true,
                })
                .then(({ data }) => {
                    if (data.code === 0) {
                        this.options_cascader = data.data
                    }
                })
                .catch();
        },
        openDistributeDialog() {
            // this.cateId = id
            let res = this.allKeysFalsyOrEmptyArray(this.searchArr)
            if (res) {
                this.$confirm('您未筛选任何条件,确认分配吗?', '是否分配', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warnig' }).then(() => {
                    this.loadCaller()
                    this.dialog = true
                }).catch(() => {
                    return false
                })
            } else {
                this.loadCaller()
                this.dialog = true
            }

        },
        loadCaller() {
            this.$axios.get('api/api3_call_task/get_caller', {
                loadingClose: true
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.callerOptions = data.data
                }
            }).catch()
        },
        closeDialog_taskCate() {
            this.cateId = ''
            this.$refs.taskCate.task_cate = {
                first_level: '',
                second_level: '',
            }
            this.showNext = false
            // this.distribute.avgNum = null
            // if (this.$refs.checkboxCom) this.$refs.checkboxCom.checkList = []

            // if (this.$refs.checkboxInput) this.$refs.checkboxInput.avgNum = {}

            // if ( this.$refs.buttonGroup ) this.$refs.buttonGroup.showButtonGroup = this.distribute.dis_type
        },
        beforeCloseDialog_taskCate(done) {

        },
        closeDialog_taskBuildDetail() {

        },
        beforeCloseDialog_taskBuildDetail(done) {

        },
        closeDialog() {
            this.cateId = ''
            this.$refs.taskCate.task_cate = {
                first_level: '',
                second_level: '',
            }
            this.showNext = false
            this.distribute.avgNum = null
            if (this.$refs.checkboxCom) this.$refs.checkboxCom.checkList = []

            if (this.$refs.checkboxInput) this.$refs.checkboxInput.avgNum = {}

            // if ( this.$refs.buttonGroup ) this.$refs.buttonGroup.showButtonGroup = this.distribute.dis_type
        },
        beforeCloseDialog(done) {

        },
        buttonGroupChange(val) {
            this.distribute.dis_type = val
        },
        submitFormDis(formName) {
            this.distribute.cateId = this.cateId
            this.distribute.searchArr = this.searchArr
            if (this.distribute.dis_type === 1) {
                this.distribute.checkBoxCom = this.$refs.checkboxCom.checkList
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.$axios
                            .post('/api/api3_call_task/distribute', this.distribute)
                            .then(res => {
                                const { data } = res
                                if (data.code === 0) {
                                    this.$message.success(data.msg)
                                    // this.loadTable()
                                    this.dialog = false
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                    } else {
                        return false
                    }
                })
            } else if (this.distribute.dis_type === 2) {
                this.distribute.checkboxInput = this.$refs.checkboxInput.avgNum
                this.$axios
                    .post('/api/api3_call_task/distribute', this.distribute)
                    .then(res => {
                        const { data } = res
                        if (data.code === 0) {
                            this.$message.success(data.msg)
                            this.loadTable()
                            this.dialog = false
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
            } else {
                return false
            }
        },
        handleSelected(id) {
            this.cateId = id
            this.showNext = id ? true : false
        },
        handleSelectedNew(id) {
            this.cateId = id
            this.showNext = id ? true : false
            // this.callBuildTask()
        },
        allKeysFalsyOrEmptyArray(obj) {
            return Object.keys(obj).every(key => {
                let value = obj[key];
                if (Array.isArray(value)) {
                    return value.length === 0;  // 判断是否为空数组
                } else {
                    return !value;  // 判断是否为假
                }
            });
        },
        buildTask() {
            let res = this.allKeysFalsyOrEmptyArray(this.searchArr)
            if (res) {
                this.$confirm('您未筛选任何条件,确认创建吗?', '是否创建', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warnig' }).then(() => {
                    this.taskCateDialog = true
                }).catch(() => {
                    return false
                })
            } else {
                this.taskCateDialog = true
            }

        },
        callBuildTask() {
            this.$axios.get(`${AutoHyperfHost}qyh/call_task/enterpriseQualificationBuildTask`, {
                loadingClose: true,
                params: {
                    searchArr: this.$refs.enterpriseQualificationDataFiltering.searchArr,
                    cate_id: this.cateId
                },
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.$refs.EnterpriseQualificationSearchBuildTask.taskCateDialog = false
                    this.$message.success(data.msg)
                    this.taskBuildDetailDialog = true
                } else {
                    this.$message.warning(data.msg)
                }
            }).catch()
        }
    },
    computed: {
        validToOptions: function () {
            // var _this = this
            return {
                shortcuts: [
                    {
                        text: '无',
                        onClick(picker) {
                            picker.$emit('pick', '无')
                        }
                    },
                ]
            }
        },
        start_placeholder() {
            if (this.searchArr.valid_to === '无') return '无'
            return '开始日期'
        },
        end_placeholder() {
            if (this.searchArr.valid_to === '无') return ''
            return '结束日期'
        },
        range_separator() {
            if (this.searchArr.valid_to === '无') return ''
            return '至'
        }
    },
    watch: {
        cateId(n) {
            if (n) this.callBuildTask()
        }
    },
}
</script>

<style scoped>
.enterprise-qualification-search .form-horizontal {
    display: flex;
    justify-content: space-between;
    /* 横向排列并设置间距 */
    flex-wrap: wrap;
    /* 允许换行 */
}

.enterprise-qualification-search .form-horizontal .el-form-item {
    flex-grow: 1;
    /* 让每个item都有相同的生长度 */
    flex-basis: 0;
    /* 初始长度为0 */
    margin-right: 10px;
    /* 设置右边距 */
}

.enterprise-qualification-search .form-horizontal .el-form-item:last-child {
    margin-right: 0;
    /* 最后一个item不设置右边距 */
}

.enterprise-qualification-search .form-horizontal>>>.el-form-item__label {
    /* background-color: #409EFF; */
    color: #E6A23C;
    font-size: medium;
    font-weight: bold;
    /* border-radius: 10px; */
}

.enterprise-qualification-search .cal-tas-m-dia-title {
    font-size: large;
    font-weight: bold;
    color: #409EFF;
}

.enterprise-qualification-search .cal-tas-m-bg-con {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}

.enterprise-qualification-search .box-card {
    margin-top: 0.2rem;
    width: 480px;
}

.enterprise-qualification-search .clearfix:after {
    clear: both
}

.enterprise-qualification-search .clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.enterprise-qualification-search .text {
    font-size: 14px;
}

.enterprise-qualification-search .item {
    margin-bottom: 18px;
}

.enterprise-qualification-search>>>.el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 200px);
    max-width: calc(100% - 30px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, .3);
}
</style>


// WEBPACK FOOTER //
// src/pages/CallTaskResource/components/EnterpriseQualificationSearch.vue